import { trendsActions } from '../../../actions/trends/trends'
import { TREND_KEYWORD_TYPES } from './get-trend-filter-items'

/**
 * Fetch trends based on selected type and handle business logic
 * @param {string} assetId - Asset ID
 * @param {string} selectedTrendType - Selected trend type
 * @param {string} errorMessage - Custom error message
 * @returns {Promise<Array>} - Array of trend objects
 */
export const fetchTrends = async (assetId, selectedTrendType, errorMessage) => {
  // Determine which trend keyword type to use
  const trendKeywordType = selectedTrendType
    ? parseInt(selectedTrendType)
    : TREND_KEYWORD_TYPES.UNRELATED
  
  // Use the trends action to fetch data
  return await trendsActions.getTrends(assetId, trendKeywordType, errorMessage)
}
